module.exports = "app-stadium-camera-360 {\n  width: 100%;\n  height: 50vh;\n  display: block; }\n\n.camera-info {\n  max-height: 45vh;\n  overflow-y: auto; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/stadium-admin/stadium-admin.component.scss
// module id = ./src/app/views/stadium-admin/stadium-admin.component.scss
// module chunks = main